import { sanitizeString } from "src/constants";
import axios from "axios";
import moment from "moment";
import { strapiUrl } from "src/modules/users/constants";
import { isStrapi } from "../config/systemSwitch";
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { isPWA } from "src/utils/mobile";

export const uploadFile = (
  file: File,
  path: string,
  idFolderStrapi: string,
  apiStrapi: string,
  createElemInStrapi: boolean,
  titleDocument?: string
) => {
  return new Promise(async (resolve, reject) => {
    let newname =
      (!titleDocument &&
        file.name.substring(0, file.name.lastIndexOf(".")).toLowerCase()) ||
      sanitizeString(titleDocument || "");
    newname = `${newname}_${moment().unix()}`;
    let extension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    let fullName = `${newname}${extension}`;
    const newFileName = fullName;

    let token: string | null = null;

    if (!isPWA()) {
      const result = await SecureStoragePlugin.get({ key: 'accessToken' });
      token = result.value;
    }

    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    if (isStrapi && createElemInStrapi) {
      const form = new FormData();
      const newFile = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });
      form.append("file", newFile);
      form.append("folderId", idFolderStrapi);

      try {
        axios
          .post(`${strapiUrl}media/upload`, form, { headers, withCredentials: true })
          .then((uploadRes) => {
            const uploadedFile = uploadRes.data?.data?.[0];
            if (!uploadedFile?.id) {
              reject(new Error("Strapi upload: empty response"));
              return;
            }
            console.log("✅ Файл загружен:", uploadedFile);
            return axios.post(
              `${strapiUrl}${apiStrapi}`,
              {
                data: {
                  File: uploadedFile.id,
                },
              },
              { headers, withCredentials: true }
            ).then((createRes) => {
              const createdDoc = createRes.data?.data;
              if (!createdDoc) {
                reject(new Error("Strapi create entry: empty response"));
                return;
              }
              const result = {
                path: uploadedFile.url,
                id: createdDoc.documentId ?? createdDoc.id,
                guid: uploadedFile.id,
              };
              resolve(result);
            });
          })
          .catch((err) => {
            console.error("❌ Ошибка загрузки файла в Strapi", err);
            reject(err);
          });
      } catch (err) {
        console.error("❌ Ошибка", err);
        reject(err);
      }
    } else {
      reject(
        new Error(
          "uploadFile: Strapi upload is disabled (isStrapi or createElemInStrapi is false)"
        )
      );
    }
  });
};
